import { Link } from 'react-router-dom';
import { animeCategories } from '@/mocks/anime';

interface CategoryNavProps {
  activeCategory?: string;
}

export default function CategoryNav({ activeCategory }: CategoryNavProps) {
  return (
    <section id="categories" className="py-12 md:py-16 bg-background-900/50">
      <div className="container-custom">
        <div className="text-center mb-8">
          <h2 className="section-title">动漫分类</h2>
          <p className="section-subtitle">按类型快速找到你想看的番剧</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
          {animeCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`flex flex-col items-center gap-2 p-4 rounded-xl transition-all duration-200 cursor-pointer group ${
                activeCategory === cat.slug
                  ? 'bg-primary-500/20 border border-primary-500/40'
                  : 'bg-background-800/50 border border-background-700/50 hover:border-primary-500/30 hover:bg-background-800'
              }`}
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-lg transition-colors ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-700 text-foreground-400 group-hover:bg-primary-500/20 group-hover:text-primary-400'
              }`}>
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <span className={`text-xs font-medium whitespace-nowrap ${
                activeCategory === cat.slug ? 'text-primary-400' : 'text-foreground-400'
              }`}>
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}